module.exports = __webpack_public_path__ + "img/Line 736.e9207948.png";